import React, { FC, Suspense, lazy } from 'react';
import useLocalStorage from 'react-use-localstorage';
import { Redirect, Route, Switch } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';

import { RequireAuth } from './common/Auth';

const Airing = lazy(() => import('./airings/Airing'));
const Airings = lazy(() => import('./airings/Airings'));
const Audits = lazy(() => import('./audit/Audits'));
const Channel = lazy(() => import('./channels/Channel'));
const Channels = lazy(() => import('./channels/Channels'));
const Composer = lazy(() => import('./highlights/Composer'));
const Fer = lazy(() => import('./games/Fer'));
const Game = lazy(() => import('./games/Game'));
const Games = lazy(() => import('./games/Games'));
const Highlight = lazy(() => import('./highlights/Highlight'));
const LatestHighlight = lazy(() => import('./airings/LatestHighlight'));
const Report = lazy(() => import('./report/Report'));

const LoadingFallback = (): JSX.Element => (
	<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
		<CircularProgress />
	</div>
);

const Routes: FC = () => {
	const [item] = useLocalStorage('loginpath', '');

	return (
		<Suspense fallback={<LoadingFallback />}>
			<Switch>
				<RequireAuth>
					<Route exact path='/' render={(): JSX.Element => <Redirect to={item.includes('report') ? '/report' : '/games'} />} />

					<Route exact path='/airings'>
						<Airings />
					</Route>
					<Route exact path='/airings/:id'>
						<Airing />
					</Route>
					<Route exact path='/airings/:id/edit'>
						<Airing edit='edit' />
					</Route>
					<Route exact path='/airings/:id/compose-highlight'>
						<Composer mode={'airing'} />
					</Route>
					<Route exact path='/airings/:id/editorial-highlight'>
						<Airing edit='editorialHighlight' />
					</Route>
					<Route exact path='/airings/:id/excluded-clips'>
						<Airing edit='exclusions' />
					</Route>
					<Route exact path='/airings/:id/latest-highlight'>
						<LatestHighlight />
					</Route>

					<Route exact path='/audit'>
						<Audits />
					</Route>

					<Route exact path='/channels'>
						<Channels />
					</Route>
					<Route exact path='/channels/:id'>
						<Channel />
					</Route>
					<Route exact path='/channels/:id/edit'>
						<Channel edit={true} />
					</Route>

					<Route exact path='/games'>
						<Games />
					</Route>
					<Route exact path='/games/:gameId/fers/:ferId'>
						<Fer />
					</Route>
					<Route exact path='/games/:id'>
						<Game />
					</Route>
					<Route exact path='/games/:id/compose-highlight'>
						<Composer />
					</Route>
					<Route exact path='/games/:id/edit'>
						<Game edit='edit' />
					</Route>
					<Route exact path='/games/:id/editorial-highlight'>
						<Game edit='editorialHighlight' />
					</Route>
					<Route exact path='/games/:id/excluded-clips'>
						<Game edit='exclusions' />
					</Route>

					<Route exact path='/highlights/:id'>
						<Highlight />
					</Route>

					<Route exact path='/report'>
						<Report />
					</Route>
				</RequireAuth>
			</Switch>
		</Suspense>
	);
};

export default Routes;
